import { Middleware } from 'redux';
import { FIREBASE } from '../../core/datasets/action';
import { EventFirebase } from '../classes';
import { messagingActions } from '../../messaging/redux/messagingActions';
import { messagingSelectors } from '../../messaging/redux/messagingSelectors';
import { UnreadMessagesMap } from '../../firebase/types/redux/firebaseState';
import { countUnreadMessages } from '../../firebase/utils/firebaseUtils';

export const fireBaseMiddleware: Middleware = ({ dispatch, getState }) => {
    const updateUnreadCounter = (data: UnreadMessagesMap) => {
        const state = getState();
        const activeChannelIds = messagingSelectors.channelIds(state);
        const currentChannelId = messagingSelectors.currentChannelId(state);
        dispatch(
            messagingActions.setHasUnreadMessages(countUnreadMessages(data, activeChannelIds, currentChannelId) > 0),
        );
    };

    return (next) => async (action) => {
        next(action);

        switch (action.type) {
            case FIREBASE.SET_FIREBASE_USER: {
                const firebase = getState().firebase;

                if (!firebase.user) {
                    console.error('No firebase user is set!');
                    return;
                }
                await EventFirebase.subscribeToUnreadMessagesCount(firebase.user.uid, updateUnreadCounter);
            }
        }
    };
};
